import { Handle, Position } from 'reactflow';
import {
  Box,
  Flex,
  Text,
  IconButton,
  HStack,
  Tag,
} from '@chakra-ui/react';
import { FiGitMerge } from 'react-icons/fi';
import { FiCopy, FiEdit, FiTrash2 } from 'react-icons/fi';

const CallFlowNode = ({ data }) => {
  return (
    <Box
      bg="white"
      border="2px solid"
      borderColor="#0d9488"
      borderRadius="xl"
      boxShadow={data.selected ? 'xl' : 'lg'}
      minW="240px"
      position="relative"
    >
      <Handle
        type="target"
        position={Position.Left}
        style={{ background: '#0d9488' }}
      />

      {/* Header */}
      <Flex
        bgGradient="linear(to-r, #0d9488, #0891b2)"
        color="white"
        px={4}
        py={2.5}
        borderTopRadius="xl"
        align="center"
        gap={2}
      >
        <FiGitMerge size={16} />
        <Text noOfLines={1} flex={1} fontSize="sm" fontWeight="medium">
          Call xflow
        </Text>
        <HStack spacing={1}>
          <IconButton
            icon={<FiEdit size={14} />}
            size="xs"
            variant="ghost"
            color="white"
            _hover={{ bg: 'whiteAlpha.300' }}
            onClick={(e) => { e.stopPropagation(); data.onEdit?.(data.id); }}
            aria-label="Edit"
          />
          <IconButton
            icon={<FiCopy size={14} />}
            size="xs"
            variant="ghost"
            color="white"
            _hover={{ bg: 'whiteAlpha.300' }}
            onClick={(e) => { e.stopPropagation(); data.onDuplicate?.(data.id); }}
            aria-label="Duplicate"
          />
          <IconButton
            icon={<FiTrash2 size={14} />}
            size="xs"
            variant="ghost"
            color="white"
            _hover={{ bg: 'whiteAlpha.300' }}
            onClick={(e) => { e.stopPropagation(); data.onDelete?.(data.id); }}
            aria-label="Delete"
          />
        </HStack>
      </Flex>

      {/* Body */}
      <Box p={3.5}>
        <Text fontSize="sm" fontWeight="medium" mb={1.5}>
          {data.label || 'Call xflow'}
        </Text>

        {data.selectedFlowName ? (
          <Flex
            align="center"
            gap={1.5}
            bg="teal.50"
            borderRadius="md"
            px={2}
            py={1}
            border="1px solid"
            borderColor="teal.200"
            mb={2}
          >
            <FiGitMerge size={12} color="#0d9488" />
            <Text fontSize="xs" fontWeight="medium" color="teal.700" noOfLines={1}>
              {data.selectedFlowName}
            </Text>
          </Flex>
        ) : (
          <Flex
            align="center"
            gap={1.5}
            bg="gray.50"
            borderRadius="md"
            px={2}
            py={1}
            border="1px dashed"
            borderColor="gray.300"
            mb={2}
          >
            <Text fontSize="xs" color="gray.400">No flow selected</Text>
          </Flex>
        )}

        {data.flowStatus && (
          <Tag
            colorScheme={data.flowStatus === 'active' ? 'green' : 'gray'}
            variant="subtle"
            fontSize="xs"
          >
            {data.flowStatus}
          </Tag>
        )}
      </Box>

      <Handle
        type="source"
        position={Position.Right}
        style={{ background: '#0d9488' }}
      />
    </Box>
  );
};

export default CallFlowNode;
